import { LoaderStyled } from './style';

export const TableLoader = () => <LoaderStyled></LoaderStyled>;
